import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  ON_EDGE_ADD_BLOCK_MENU: `${cleanedFilename(
    __filename,
  )}-on-edge-add-block-menu`,
};
